import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { SHADOW_TOKENS } from '../../../design-system/tokens/shadows';

/**
 * Foundations › Shadows — traslado del frame "Shadows" de Figma (node 4:544).
 * Tabla Name | Propósito | Shadow: cada fila muestra el token y un preview con la
 * sombra aplicada. Header limpio (como Spacing/Semantic Colors).
 *
 * Datos desde la fuente de verdad `SHADOW_TOKENS` (reusa `var(--shadow-*)` del proyecto).
 */
export const DSShadowsPage: React.FC = () => (
  <div className="px-10 py-12">
    <div className="mx-auto flex w-full max-w-[800px] flex-col gap-10">
      <PageHeader
        title="Shadows"
        description="Las sombras permiten añadir profundidad y realismo a los diseños al posicionar elementos sobre un eje z."
      />

      <div className="w-full">
        {/* Head — mismo estilo que Spacing/Semantic (sin fondo, sólo borde inferior) */}
        <div className="flex items-center gap-8 border-b border-neutral-300 px-4 py-3 text-[14px] font-semibold text-neutral-900">
          <div className="w-[130px] shrink-0">Name</div>
          <div className="min-w-0 flex-1">Propósito</div>
          <div className="w-[200px] shrink-0">Shadow</div>
        </div>

        {/* Filas */}
        {SHADOW_TOKENS.map((token) => (
          <div key={token.name} className="flex items-center gap-8 px-4 py-5">
            <div className="w-[130px] shrink-0">
              <code className="rounded bg-neutral-100 px-1.5 py-0.5 font-mono text-[13px] text-neutral-700">
                {token.name}
              </code>
            </div>
            <div className="min-w-0 flex-1 text-[16px] text-neutral-600">{token.purpose}</div>
            <div className="w-[200px] shrink-0">
              <div
                className="h-14 w-full rounded-xl bg-white"
                style={{ boxShadow: token.boxShadow }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);
